"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.ImageWrapper = exports.Image = exports.ContainerDiv = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
  position: relative;
  height: 100vh;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  &.animation-transform,
  > div {
    will-change: transform;
  }
`;
exports.Wrapper = Wrapper;
const ContainerDiv = _styledComponents.default.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: row !important;
  flex-wrap: nowrap;
  height: 100%;
  align-items: center;

  padding: ${props => `0
        calc((100vw - (${props.fullHeight ? 100 : 90} * ${props.lastImgAspectRatio}${props.fullHeight ? 'vw' : 'vh'})) / 2)
        0
        calc((100vw - (${props.fullHeight ? 100 : 90} * ${props.firstImgAspectRatio}${props.fullHeight ? 'vw' : 'vh'})) / 2)`};
`;
exports.ContainerDiv = ContainerDiv;
const ImageWrapper = _styledComponents.default.div`
  padding: ${props => props.imagePadding ? '0 8px' : '0'};
  width: ${props => props.fullHeight ? `calc(${100 * props.aspectRatio}vh)` : `calc(${90 * props.aspectRatio}vh - ${90 * props.aspectRatio}px)`};

  height: ${props => props.fullHeight ? '100vh' : 'unset'};
`;
exports.ImageWrapper = ImageWrapper;
const Image = _styledComponents.default.img`
  max-width: 100%;
  height: ${props => props.fullHeight ? '100%' : 'calc(90vh - 90px)'};
`;
exports.Image = Image;
//# sourceMappingURL=styles.js.map